import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../constants';

 const useTicketModal = () => {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [selectedTicketNumber, setSelectedTicketNumber] = useState(null);

  const handleOpenModal = (ticketId, ticketNumber) => {
    console.log("Opening modal for ticket:", ticketId, ticketNumber);
    setSelectedTicketId(ticketId);
    setSelectedTicketNumber(ticketNumber);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedTicketId(null);
    setSelectedTicketNumber(null);
  };

  const handleOnUpload = async (uploadData, setAllRows) => {
    try {
      console.log("Upload completed successfully:", uploadData);

      setAllRows((prevRows) =>
        prevRows.map((row) =>
          row.ticketNumber === selectedTicketNumber
            ? { ...row, physicalDocumentReceived: true }
            : row
        )
      );

      history.push(
        ROUTES.GOTOQUESTIONNAIRE(selectedTicketId, selectedTicketNumber)
      );
    } catch (err) {
      console.error("Error handling upload:", err);
    }
  };

  return {
    isModalOpen,
    selectedTicketId,
    selectedTicketNumber,
    handleOpenModal,
    handleCloseModal,
    handleOnUpload
  };
};

export default useTicketModal;